import React, { FC, memo } from 'react';
import AntDesign from 'react-native-vector-icons/AntDesign';

import dynamicSize from '@webtrader/core/dynamic-size';

import { IVectorIconProps } from './index';

AntDesign.loadFont();

type AntDesignIconsName = 'profile' | 'delete' | 'user' | 'mail' | 'phone' | 'earth';

const AntDesignIcon: FC<IVectorIconProps<AntDesignIconsName>> = (props) => {
  const { name, color, size = 20, ...restProps } = props;

  return <AntDesign {...restProps} name={name} color={color} size={dynamicSize.convertSize(size)} />;
};

export default memo(AntDesignIcon);
